import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, message, Popconfirm, Space, Spin, Table } from 'antd';
import classnames from 'classnames';
import { get, isEmpty } from 'lodash';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Nav, NavItem, NavLink } from 'reactstrap';
import VehiclePartnerApi from '../../../functions/api/partner/VehiclePartner';
import TypeApi, { VEHICLE_TYPES } from '../../../functions/api/vehicle/TypeApi';
import MyUtil from '../../../functions/MyUtil';
import ButtonFeatured from '../ButtonFeatured';
import ButtonHide from '../ButtonHide';
import ButtonView from '../ButtonView';

class ListVehiclePartner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedVehicleType: VEHICLE_TYPES.CAR,
      types: [],
      isLoading: false,
    };
  }

  async componentDidMount() {
    const types = (await TypeApi.getAll()) || [];

    const listCars = await VehiclePartnerApi.getAllVehiclePartner({
      vhc_type_id: VEHICLE_TYPES.CAR,
      part_id: this.props.part_id,
    });

    this.setState({
      vehicles: listCars,
      types,
    });
  }

  handleChangeHide = async (checked, row) => {
    await VehiclePartnerApi.updateSimple(row.vhc_type_id, checked);
  };

  buttonHide = (cell, row) => {
    return <ButtonHide cell={cell} row={row} />;
  };

  buttonFeatured = (cell, row) => {
    return <ButtonFeatured cell={cell} row={row} />;
  };

  handleInsertButtonClick = () => {
    const { selectedVehicleType } = this.state;
    const { match_parent } = this.props;
    if (selectedVehicleType === VEHICLE_TYPES.CAR) {
      return this.props.history.push(`${match_parent.url}/add-car-partner`);
    }

    return this.props.history.push(`${match_parent.url}/add-motorbike-partner`);
  };

  handleChangeList = (list) => {
    const { selectedVehicleType } = this.state;
    if (selectedVehicleType === VEHICLE_TYPES.CAR)
      this.setState({ listCars: list });
    else this.setState({ listMotorbikes: list });
  };

  toggle = async (newlySelectedVhcType) => {
    const { selectedVehicleType } = this.state;

    if (selectedVehicleType !== newlySelectedVhcType) {
      this.setState({
        selectedVehicleType: newlySelectedVhcType,
        vehicles: [],
      });
    }

    const params = {
      vhc_type_id: Number(newlySelectedVhcType),
      part_id: this.props.part_id,
    };
    const result = await VehiclePartnerApi.getAllVehiclePartner(params);

    const vehicles = MyUtil.formatListVehicle(result, newlySelectedVhcType);
    this.setState({ vehicles });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => confirm()}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={confirm}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button onClick={clearFilters} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
  });

  getColumnDropDownFilter(dataIndex) {
    const { vehicles } = this.state;
    const filters = vehicles
      .map((b) => get(b, dataIndex))
      .filter((option, index, all) => all.indexOf(option) === index)
      .filter((o) => !isEmpty(o))
      .map((o) => ({
        text: o,
        value: o,
      }));

    return {
      filters,
      onFilter: (value, record) => get(record, dataIndex) === value,
    };
  }

  handleDelete = async (key) => {
    try {
      const { vehicles } = this.state;
      await VehiclePartnerApi.deleteVehiclePartner(key);

      message.success(`Đã xóa ${key}`);

      this.setState({
        vehicles: vehicles.filter((vp) => vp.vhc_part_id !== key),
      });
    } catch (e) {
      message.error(`Lỗi: ${e.message}`);
    }
  };

  render() {
    const { types, vehicles, selectedVehicleType } = this.state;
    if (types.length === 0) {
      return <Spin />;
    }

    const columnCars = [
      {
        title: 'Mã xe',
        dataIndex: 'vhc_part_id',
        key: 'vhc_part_id',
        fixed: 'left',
      },
      {
        title: 'Tên đối tác',
        dataIndex: 'part_name',
        key: 'part_name',
        fixed: 'left',
        ...this.getColumnSearchProps('part_name'),
      },
      {
        title: 'Thành phố',
        dataIndex: 'city_name',
        key: 'city_name',
        ...this.getColumnDropDownFilter('city_name'),
      },
      {
        title: 'Quận',
        dataIndex: 'district_name',
        key: 'district_name',
        ...this.getColumnDropDownFilter('district_name'),
      },

      {
        title: 'Tên xe',
        dataIndex: 'vhc_part_name',
        key: 'vhc_part_name',
        ...this.getColumnSearchProps('vhc_part_name'),
      },
      {
        title: 'Số chỗ',
        dataIndex: 'vhc_seat_num',
        align: 'right',
        ...this.getColumnDropDownFilter('vhc_seat_num'),
      },
      {
        title: 'Động cơ',
        dataIndex: 'vhc_tms_name',
        align: 'right',
        ...this.getColumnDropDownFilter('vhc_tms_name'),
      },
      {
        title: 'Giá cơ bản',
        dataIndex: 'vhc_part_defa_prie',
        key: 'vhc_part_defa_prie',
      },
      {
        title: 'Ẩn hiện xe',
        render: this.buttonHide,
      },
      {
        title: 'Đánh dấu nổi bật',
        render: this.buttonFeatured,
      },
      {
        title: 'Chỉnh sửa',
        fixed: 'right',
        render: (text, record) => {
          return (
            <Space>
              <Button
                size="small"
                onClick={() =>
                  this.props.history.push(
                    `/vehicle-partner/edit-car-vehicle-partner/${record.vhc_part_id}`
                  )
                }
              >
                <i className="fas fa-edit"></i>
              </Button>
              <ButtonView
                vehiclePartner={record}
                onChangeList={this.handleChangeList}
              />
              <Popconfirm
                title="Bạn chắc chắn muốn xóa?"
                onConfirm={() => this.handleDelete(record.vhc_part_id)}
              >
                <Button size="small" danger>
                  <i className="fas fa-trash"></i>
                </Button>
              </Popconfirm>
            </Space>
          );
        },
      },
    ];

    const columnMotobikes = [
      {
        title: 'Mã xe',
        dataIndex: 'vhc_part_id',
        key: 'vhc_part_id',
        fixed: 'left',
      },
      {
        title: 'Tên đối tác',
        dataIndex: 'part_name',
        key: 'part_name',
        fixed: 'left',
        ...this.getColumnSearchProps('part_name'),
      },
      {
        title: 'Thành phố',
        dataIndex: 'city_name',
        key: 'city_name',
        ...this.getColumnDropDownFilter('city_name'),
      },
      {
        title: 'Quận',
        dataIndex: 'district_name',
        key: 'district_name',
        ...this.getColumnDropDownFilter('district_name'),
      },
      {
        title: 'Tên xe',
        dataIndex: 'vhc_part_name',
        key: 'vhc_part_name',
        ...this.getColumnSearchProps('vhc_part_name'),
      },
      {
        title: 'Giá cơ bản',
        dataIndex: 'vhc_part_defa_prie',
        key: 'vhc_part_defa_prie',
      },
      {
        title: 'SL',
        dataIndex: 'vhc_part_qaty_aval',
        key: 'vhc_part_qaty_aval',
      },
      {
        title: 'Ẩn hiện xe',
        render: this.buttonHide,
      },
      {
        title: 'Chỉnh sửa',
        fixed: 'right',
        render: (text, record) => {
          return (
            <Space>
              <Button
                size="small"
                onClick={() =>
                  this.props.history.push(
                    `/vehicle-partner/edit-moto-vehicle-partner/${record.vhc_part_id}`
                  )
                }
              >
                <i className="fas fa-edit"></i>
              </Button>
              <ButtonView
                vehiclePartner={record}
                onChangeList={this.handleChangeList}
              />
              <Popconfirm
                title="Bạn chắc chắn muốn xóa?"
                onConfirm={() => this.handleDelete(record.vhc_part_id)}
              >
                <Button size="small" danger>
                  <i className="fas fa-trash"></i>
                </Button>
              </Popconfirm>
            </Space>
          );
        },
      },
    ];

    return (
      <>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames(
                { active: selectedVehicleType === VEHICLE_TYPES.CAR },
                'nav-tab'
              )}
              onClick={() => this.toggle(VEHICLE_TYPES.CAR)}
            >
              Ô TÔ
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames(
                { active: selectedVehicleType === VEHICLE_TYPES.MOTOBIKE },
                'nav-tab'
              )}
              onClick={() => this.toggle(VEHICLE_TYPES.MOTOBIKE)}
            >
              XE MÁY
            </NavLink>
          </NavItem>
        </Nav>

        <div>
          <Button
            onClick={this.handleInsertButtonClick}
            type="primary"
            size="large"
          >
            Thêm
          </Button>
        </div>

        <Table
          rowKey="vhc_part_id"
          size="small"
          columns={
            selectedVehicleType === VEHICLE_TYPES.CAR
              ? columnCars
              : columnMotobikes
          }
          dataSource={vehicles}
          scroll={{ x: 'max-content' }}
        />
      </>
    );
  }
}

export default withRouter(ListVehiclePartner);
